import PropTypes from "prop-types";
import React from "react";

import DeleteRouteForm from "v2/components/responsive/DeleteRouteForm";
import ModalLink from "v2/components/responsive/ModalLink";

const DeleteRouteLink = (props, context) => {
  const {params: {date, routeId}} = context;
  return (
    <ModalLink
      form={DeleteRouteForm}
      label="Delete Route"
      url={`/${date}/${routeId}/delete`}
      {...props} />
  );
};

DeleteRouteLink.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
};

export default DeleteRouteLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/DeleteRouteLink.js
 **/